import { SimpleMappedStorePresentation } from "@core/store/mappedStorePresentation";
import { SimpleStore } from "@core/store/store";
import { CurrencyCode, CurrencyConversion } from "./currency";
import { CurrencyApi } from "./currencyApi";

export class CurrencyService {
	currencyStore = new SimpleStore((id) => this.currencyApi.getCurrency(id));
	currenciesStore = new SimpleMappedStorePresentation(this.currencyStore, () => this.currencyApi.getCurrencies());
	constructor(private readonly currencyApi: CurrencyApi) {}

	async getConversion(baseCurrency: CurrencyCode, value: number): Promise<Partial<CurrencyConversion>> {
		const result = await await this.currencyApi.getConversion(baseCurrency, value);
		return result;
	}
}
